// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground, inverseIcon } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var snackbarColors = function(mode) {
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    var inverseBg = inverseBackground(mode);
    var inverseIc = inverseIcon(mode);
    return {
        default: {
            action: tx.action,
            background: inverseBg.level200,
            icon: inverseIc.heaviest,
            text: tx.action
        },
        error: {
            action: tx.white,
            background: bg.status.errorBold2,
            icon: ic.white,
            text: tx.white
        },
        info: {
            action: tx.white,
            background: bg.status.infoBold2,
            icon: ic.white,
            text: tx.white
        },
        success: {
            action: tx.black,
            background: bg.status.successBold2,
            icon: ic.black,
            text: tx.black
        },
        warning: {
            action: tx.black,
            background: bg.status.warningBold1,
            icon: ic.black,
            text: tx.black
        }
    };
};

//# sourceMappingURL=snackbarColors.js.map